var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page.meta)?_c('TabFilter',{attrs:{"list":_vm.filterableStatus,"totals":_vm.totalPerStatus,"selected":_vm.selected,"selected-key":"id"},on:{"selected":_vm.handleSelectStatus}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }